import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import useModal from 'ui/partials/Modal/useModal';
import { useAdminParams } from 'utils/helpers';

import c from '../../utils/constants';

export default function useGmailBulkMarkAsRead() {
  const queryClient = useQueryClient();
  const { accountId, accountUserId } = useAdminParams();
  const { hideModal } = useModal();

  const { state } = useProvider();
  const args = state;

  return useMutation({
    mutationFn: async ({
      messageIds = [],
      from,
    }: {
      messageIds: string[];
      threadId: string;
      from: string;
    }) => {
      const api = new Api(args);

      const data = await api.post(
        await withAcl({
          account: {
            url: `api/v1/channels/google/mail/mark-as-read/`,
            params: { from },
            payload: {
              messageIds,
            },
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/channels/google/mail/mark-as-read`,
            params: { from },
            payload: {
              messageIds,
            },
          },
        }),
      );

      return data?.data;
    },
    onSuccess: (_, { threadId }: { threadId: string }) => {
      queryClient.invalidateQueries({
        queryKey: [c.GMAIL_THREADS, threadId],
      });
      hideModal();
    },
  });
}
